

export const trackEvent = (eventName, values) => {
    window.analytics.track(eventName, values)
  }

  export const trackIdentity = (userId, values) => {
    console.log('identity',userId,values);
  window.analytics.identify(userId, values);
}
export const trackPage = (pageName) => {
    window.analytics.page(pageName);
}